export default __webpack_public_path__ + "static/media/login.e95c92fa.png";